import { ApiFilters } from "../store/store.types";

export const getClinicFromFilter = (recordsFilter: ApiFilters | null, entity: string) => {
  const entityRecordsFilter = recordsFilter ? recordsFilter[entity] : null;

  if (!entityRecordsFilter?._and || !Array.isArray(entityRecordsFilter._and)) {
    return -1;
  }

  const clinicFilter = entityRecordsFilter._and.find(
    (filter: any) => filter.clinic
  );

  // If no clinic filter found or _eq value doesn't exist, return -1 (all clinics)
  if (!clinicFilter?.clinic?._eq) return -1;

  // 2 is the virtual clinic id, so we skip it and return -1 instead
  return clinicFilter.clinic._eq && clinicFilter.clinic._eq !== 2 ? clinicFilter.clinic._eq : -1;
};